import { WidgetType, WidgetHeaderType, WidgetFooterType } from '../widget.types';
import { Resource } from '@topconagriculture/permissions';
export const AlertWidgetConfig = {
    type: WidgetType.ALARM,
    single: true,
    thumbnail: '/assets/images/dashboard/widget-catalog/alarms.jpg',
    title: 'widget:alert:title',
    description: 'widget:tasks:description',
    permissions: [Resource.FLEET],
    header: {
        type: WidgetHeaderType.GENERIC,
    },
    footer: (config) => ({
        type: WidgetFooterType.VIEW_MORE,
        href: config.ALARMS_VIEW_MORE_LINK,
        text: 'widget:generic:footer_text',
    }),
    baseConfig: {
        type: WidgetType.ALARM,
        w: 1,
        h: 2,
        x: 0,
        y: 0,
    },
};
//# sourceMappingURL=AlertWidgetConfig.js.map